<style lang="less" scoped>
#csv {
  display: none;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="page-content">
          <div class="title">{{ deviceTitle }}{{ optionData.title }}数据统计</div>
          <div class="content">
            <el-form label-width="80px" :rules="rules" :model="ruleForm" ref="ruleForm">
              <el-row :gutter="10">
                <div class="searchs">
                  <el-form-item label="时间" prop="startTime">
                    <el-date-picker
                      v-model="ruleForm.startTime"
                      type="datetime"
                      :default-time="'00:00:00'"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="开始时间"
                      clearable
                    ></el-date-picker>
                    <!-- <el-date-picker
                      v-model="ruleForm.time"
                      type="datetimerange"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                    ></el-date-picker>-->
                  </el-form-item>
                  <div class="interval">-</div>
                  <el-form-item label label-width="0" prop="endTime">
                    <el-date-picker
                      v-model="ruleForm.endTime"
                      type="datetime"
                      :default-time="'23:59:59'"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="结束时间"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="自动站" prop="station" v-if="station.length>1">
                    <el-select v-model="ruleForm.station" clearable placeholder="请选择">
                      <el-option
                        v-for="(item,index) in station"
                        :key="index"
                        :label="item.station_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button
                    class="subbtn"
                    @click="search(ruleForm.startTime,ruleForm.endTime)"
                    type="primary"
                    :loading="submitBtn.isBtnLoading"
                    :disabled="submitBtn.isDisabled"
                  >{{ submitBtn.btnText }}</el-button>
                </div>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="page-main-bottom">
        <div class="content-list" v-if="type=='AirosolData'&&name=='flow'">
          <statistics-echarts-option-bar
            :echart-id="'echart1'"
            :option-data="optionData"
            v-on:downCsvBtn="downCsvBtn"
          ></statistics-echarts-option-bar>
        </div>
        <div class="content-list" v-else>
          <statistics-echarts-option
            :echart-id="'echart1'"
            :option-data="optionData"
            v-on:downCsvBtn="downCsvBtn"
            v-on:searchZoom="search"
            :startTime="ruleForm.startTime"
            :endTime="ruleForm.endTime"
            :pageLoading="pageLoading"
            :isShowTitle="true"
            :isZoomFun="true"
          ></statistics-echarts-option>
        </div>
        <a id="csv"></a>
      </div>
    </div>
  </div>
</template>

<script>
import statisticsEchartsOption from "@/components/statisticsEchartsOption"; //echarts渐变折线
import statisticsEchartsOptionBar from "@/components/statisticsEchartsOptionBar"; //echarts柱状图
export default {
  name: "systemData", //数据统计
  components: {
    statisticsEchartsOption: statisticsEchartsOption,
    statisticsEchartsOptionBar: statisticsEchartsOptionBar,
  },
  data() {
    return {
      pageLoading: false, //页面loading
      markerPoint: { lng: 116.404, lat: 39.915 },
      ruleForm: {
        startTime: "", //开始日期
        endTime: "", //结束日期
        station: "",
      },
      rules: {
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        station: [
          { required: true, message: "请选择自动站", trigger: "change" },
        ],
      },
      submitBtn: {
        btnText: "查询数据",
        isLoading: false,
        isDisabled: false,
      },
      optionData: {
        title: "",
        // attribute: '',
        unit: "",
        time: new Date().getTime(),
        dataX: [],
        dataY: [],
        zoomX: [],
      },
      deviceTitle: "", //设备名称
      station: [], //自动站
    };
  },
  computed: {
    id: function () {
      return this.$route.params.id || ""; //设备id
    },
    name: function () {
      return this.$route.params.name || ""; //设备数据类型
    },
    type: function () {
      return this.$route.params.type || ""; //设备type
    },
    deviceType: function () {
      return this.$route.params.deviceType || ""; //设备type=>id
    },
  },
  methods: {
    searchZoom(a, b) {
      console.log("时间", a, b);
    },
    search(startTime, endTime, isZoom) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("时间sssss", this.type, this.name);
          let startDate = new Date(startTime);
          let endDate = new Date(endTime);
          let isBar = false; //是否展示bar图
          if (startDate > endDate) {
            this.$message.error("开始时间不能大于结束时间");
          } else {
            console.log('时间',startTime, endTime)
            let hours = this.pbFunc.getDateDiff(startTime, endTime, "hour");
            console.log("hours", hours);
            let times = "1h";
            if (hours <= 1) {
              times = "1m";
            } else if (hours <= 24) {
              times = "5m";
            } else if (hours <= 168) {
              times = "1h";
            } else {
              times = "1d";
            }
            if (this.type == "AirosolData" && this.name == "flow") {
              times = "1d";
              isBar = true;
            }
            this.pageLoading = true;
            this.pbFunc
              .echartsData(
                this.ruleForm.station,
                this.type,
                startTime,
                endTime,
                this.name,
                times,
                "",
                isBar
              )
              .then((res) => {
                this.pageLoading = false;
                if (res) {
                  // console.log("res", res);
                  this.optionData.dataX = [];
                  this.optionData.dataY = [];
                  if (this.type == "AirosolData" && this.name == "flow") {
                    for (let i in res) {
                      this.optionData.dataX.push(res[i].date);
                      this.optionData.dataY.push({
                        name: res[i].sid,
                        value: res[i].max_flow,
                      });
                    }
                  } else {
                    for (let i in res) {
                      this.optionData.dataX.push(res[i].data_time);
                      this.optionData.dataY.push(res[i][this.name]);
                    }
                  }
                  if (!isZoom) {
                    this.optionData.zoomX = this.optionData.dataX;
                  }
                }
              });
          }
        }
      });
    },
    //设备单位
    getDataField(type) {
      return new Promise((resolve, reject) => {
        this.$$http("realTimeDataField", {
          device_type: type,
        })
          .then((results) => {
            if (results.data && results.status == 200) {
              resolve(results.data);
            } else {
              reject(null);
            }
          })
          .catch((err) => {});
      });
    },
    //下载
    downCsvBtn(time) {
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        this.pbFunc
          .echartsData(
            this.ruleForm.station,
            this.type,
            this.ruleForm.startTime,
            this.ruleForm.endTime,
            this.name,
            time,
            true,
            true
          )
          .then((res) => {
            // console.log('res',res)
            if (res) {
              let csv = this.optionData.title + ".csv";
              let anchor = document.getElementById("csv");
              anchor.href =
                "data:text/csv;charset=utf-8," + encodeURIComponent(res);
              anchor.target = "_blank";
              anchor.download = csv;
              anchor.click();
              this.$message.success("下载成功");
            } else {
              this.$message.error("下载失败");
            }
          });
      }
    },
    //获取自动站
    getStationList() {
      this.pbFunc.stationList(this.id).then((res) => {
        console.log("自动站列表", res);
        this.station = res.other_station_devices;
        // if (this.type === "AGS421") {
        //   window.document.title =
        //     res.name + this.optionData.title
        //       ? this.optionData.title
        //       : "剂量率" + "数据统计";
        // }
        if (this.station.length == 1) {
          this.ruleForm.station = this.station[0].id;
        }
      });
    },
  },
  created() {
    this.deviceTitle = this.pbFunc.deviceName(this.id, this.type);

    this.getStationList();
    this.getDataField(this.deviceType).then((res) => {
      if (res) {
        let fieldList = res.results;
        for (let i in fieldList) {
          if (fieldList[i].name === this.name) {
            this.optionData.title = fieldList[i].title;
            this.optionData.unit = fieldList[i].unit;
          }
        }
        window.document.title =
          this.deviceTitle + this.optionData.title + "数据统计";
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/dataStatistics/systemData.vue